import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import axiosInstance from "../../../axiosInstance";
import toast from "react-hot-toast";

const CreateMultiRide = () => {
  const [multiDaysUrl, setMultiDaysUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [frameKey, setFrameKey] = useState(0);

  const getThemeSettings = async () => {
    setIsLoading(true);
    try {
      const { data } = await axiosInstance.get("/home-data");
      const fetchedUrl = data?.homeData?.multiDaysUrl || "";
      setMultiDaysUrl(fetchedUrl);
      setFrameKey((prevKey) => prevKey + 1);
      return fetchedUrl;
    } catch (error) {
      console.error("Error fetching multi days url:", error);
      toast.error("Multi days URL not found");
      return "";
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getThemeSettings();
  }, []);

  const handleCreateRide = async () => {
    const fetchedUrl = await getThemeSettings();

    if (!fetchedUrl) {
      toast.error("Please add Multi Days URL in Theme Setting");
    }
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />

        <div className="container-fluid py-4">
          <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
            <div>
              <h1 className="h4 mb-1">Create Multi Rides</h1>
              <p className="text-muted mb-0">Open the configured multi days ride page.</p>
            </div>
            <button
              className="btn btn-primary d-inline-flex align-items-center gap-2"
              type="button"
              onClick={handleCreateRide}
              disabled={isLoading}
            >
              <i className="ri-add-circle-line" />
              Create Ride
            </button>
          </div>

          {!multiDaysUrl && !isLoading && (
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <p className="mb-2 fw-bold">Multi Days URL</p>
                <p className="text-muted mb-0">{multiDaysUrl || "Not configured"}</p>
              </div>
            </div>
          )}

          {multiDaysUrl && (
            <iframe
              key={frameKey}
              title="Create Multi Ride"
              src={multiDaysUrl}
              style={{ width: "100%", height: "82vh", border: 0, borderRadius: 8 }}
            />
          )}
        </div>

        <button
          className="btn btn-primary rounded-circle shadow-lg"
          type="button"
          onClick={handleCreateRide}
          disabled={isLoading}
          title="Create Ride"
          style={{
            position: "fixed",
            right: 24,
            bottom: 24,
            width: 56,
            height: 56,
            zIndex: 1040,
          }}
        >
          <i className="ri-add-line fs-4" />
        </button>
      </main>
    </>
  );
};

export default CreateMultiRide;
